Vue.component("checklist-items-sorting", {

  props: ["inspectionArea"],

  data() {
    return {
      area: this.inspectionArea
    };
  },

  watch: {
    inspectionArea(newValue) {
      this.area = newValue;
    }
  },

  methods: {

    setItemsSequenceFromIndex() {
      this.area.checklist_items.map((item, index) => {
        item.sequence_number = index + 1;
      });
    },

    updateAreaItemsSequence() {

      this.setItemsSequenceFromIndex();

      var updatedItems = this.area.checklist_items.map(item => {
        return { "id": item.id, "sequence_number": item.sequence_number };
      });

      axios.patch("/inspections/areas/" + this.area.id + "/items/order", {
        _method: "PATCH",
        "updatedItems": updatedItems
      }).then(response => {

      }).catch(errors => {
        toastr.error("Error reordering checklist.");
      });

    },

    save() {
      this.updateAreaItemsSequence();
      $("#modal-checklist-items-sorting").modal("hide");
    }

  }


});